export const numberValidation = (convertedValue) => {
    return typeof convertedValue === 'number' && convertedValue < 999999999999999;
}
export const nameValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z ]{0,50}$/i), message: "Field Doesn't Accept Numbers & Special Characters or Reach Maximum Character Limit"}
]
export const numberRegexValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9+]{0,20}$/i), message: "Field Doesn't Accept Characters & Special Characters or Reach Maximum Character Limit"}
];

export const emailValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/), message: "Invalid Email Address"}
];

export const additionalEmailValidation = [
    { required: false, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/), message: "Invalid Email Address"}
];

export const spaceNameValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9- ,/.9!@#$%'"(){}}_+?:&]{5,60}$/i), message: "Minimum Character Limit 5 or Reach Maximum Character Limit"}
];
export const spaceOrgNameValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9- ,/.9!@#$%'"(){}}_+?:&]{3,40}$/i), message: "Minimum Character Limit 3 or Reach Maximum Character Limit"}
];
export const spaceDescriptionValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9- ,/.9!@#$%'"(){}}_+?:&]{3,40}$/i), message: "Minimum Character Limit 3 or Reach Maximum Character Limit"}
];
export const spaceUniqueIdValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9- ,/_@#&]{0,30}$/i), message: "Invalid Unique Id or Reach Maximum Character Limit"}
];
export const spaceAddressValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9- ,/]*$/i), message: "Field Doesn't Accept Special Characters"}
];
export const spaceCityValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    // { pattern: new RegExp(/^[a-zA-Z- ,/]{0,50}$/i), message: "Field Doesn't Accept Numbers & Special Characters"}
    { pattern: new RegExp(/^[a-zA-Z0-9- ,/]*$/i), message: "Field Doesn't Accept Special Characters"}
];
export const taxRegValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9- ]{0,50}$/i), message: "Field Doesn't Accept Characters & Special Characters or Reach Maximum Character Limit"}
]
export const numberOfSeatValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9]{0,5}$/i), message: "Field Doesn't Accept Characters & Special Characters or white spaces or Reach Maximum Character Limit"}
];
export const validationNoticePeriod = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9]{0,3}$/i), message: "Field Doesn't Accept Characters & Special Characters or white spaces or Reach Maximum Character Limit"}
];
export const spaceAreaValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9.]{0,10}$/i), message: "Field Doesn't Accept Characters & Special Characters or white spaces or Reach Maximum Character Limit"}
];
export const nameOfAccountValidation = [
    {required: true, message: 'Please Fill Input Field!'},
    { pattern: new RegExp(/^[a-zA-Z0-9 !@#$`~%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,101}$/i), message: "Max character count reached"}
    // {pattern: new RegExp(/^[a-zA-Z- ,]{0,100}$/i), message: "Field Doesn't Accept Numbers & Special Characters or Reach Maximum Character Limit"}
];
export const nameOfBankValidation = [
    {required: true, message: 'Please Fill Input Field!'},
    { pattern: new RegExp(/^[a-zA-Z0-9 !@#$`~%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,101}$/i), message: "Max character count reached"}
    // {pattern: new RegExp(/^[a-zA-Z0-9- ,]{0,100}$/i), message: "Field Doesn't Accept Special Characters or Reach Maximum Character Limit"}
];
export const codesValidation = [
    {required: true, message: 'Please Fill Input Field!'},
    {pattern: new RegExp(/^[a-zA-Z0-9-]{0,30}$/i), message: "Field Doesn't Accept Special Characters & white spaces or Reach Maximum Character Limit "}
];
export const accountNumberValidation = [
    {required: true, message: 'Please Fill Input Field!'},
    {pattern: new RegExp(/^[a-zA-Z0-9-]{0,50}$/i), message: "Field Doesn't Accept Special Characters or Reach Maximum Character Limit"}
];
export const commissionValidation = [
    {required: true, message: 'Please Fill Input Field!'},
    {pattern: new RegExp(/^[0-9]{0,2}$/i), message: "Field Doesn't Accept Characters & Special Characters or Reach Maximum Character Limit"}
];
export const pricePerSeatValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9.]{0,10}$/i), message: "Field Doesn't Accept Characters & Special Characters or white spaces or Reach Maximum Character Limit"}
];
export const minimumBookingPeriod = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9]{0,3}$/i), message: "Field Doesn't Accept Characters & Special Characters or white spaces or Reach Maximum Character Limit"}
];
export const discountNameValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9- ]{0,30}$/i), message: "Field Doesn't Accept Special Characters or white spaces or Reach Maximum Character Limit"}
];
export const discountPercentageValidation = [
    { required: false, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9.]{0,3}$/i), message: "Field Doesn't Accept Special Characters or white spaces or Reach Maximum Character Limit"}
];
export const rulesPackageName=[
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9 !@#$`~%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,30}$/i), message: "Max character count reached"}
    // { pattern: new RegExp(/^[a-zA-Z0-9- ]{0,25}$/i), message: "Field Doesn't Accept Special Characters or max character count reached"}
];

export const rulesPackageDescription=[
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9 !@#$`~%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,100}$/i), message: "Max character count reached"}
];

export const rulesPackagePrice=[
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9 .]+$/i), message: "Field Doesn't Accept Special Characters & letters"}
];

export const rulesPackageQty=[
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9]{0,3}$/i), message: "Field Doesn't Accept Special Characters & letters"}
];
export const postalAddressValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9- !@#$`~%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,255}$/i), message: "Field Doesn't Accept Special Characters or Reach Maximum Character Limit"}
];

export const postalCodeValidation = [
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[a-zA-Z0-9 !@#$`~%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,15}$/i), message: "Max character count reached"}
];

export const latitudeValidation=[
    { required: true, message: 'Please Fill Input Field!' },
    { pattern: new RegExp(/^[0-9.-]{0,25}$/i), message: "Field Doesn't Accept Special Characters & letters"}
];

export const emptyValidation = [
    { required: true, message: 'Please Fill Input Field!'}
]